import React from 'react';
import ApiPage from './ApiPage';

const TermsOfService = () => {
  return (
    <ApiPage
      slug="terms"
      fallbackTitle="Terms of Service"
      seoTitle="Terms of Service | WealthDost"
      seoDescription="Review the WealthDost terms of service governing access to our platform, content, and community."
      seoPath="/terms"
    />
  );
};

export default TermsOfService;
